module.exports = __webpack_public_path__ + "img/logo-progresso.781d0357.png";